import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Title from '@/components/Title';
import ReviewCardGrid from '@/components/WukongReviews/ReviewCardGrid';
import useIsMobileNew from '@/hooks/useIsMobileNew';

/**
 * 口碑之选模块 - Chinese
 * 展示 Trustpilot 好评（数据来自 wallOfLove）
 */
const PublicPraise: React.FC = () => {
  const isSmallScreen = useIsMobileNew();
  const { t, i18n } = useTranslation(['chinese']);

  return (
    <div className="mx-auto mt-[80px] lg:mt-[130px] xl:mt-[46px]">
      {/* 标题 */}
      <div className="container">
        <Title innerHTML theme="red">
          {isSmallScreen ? t('口碑之选-标题-M') : t('口碑之选-标题')}
        </Title>
      </div>

      {/* 评分条 + 好评卡片 */}
      <ReviewCardGrid subject="chinese" />

      {/* Explore more 按钮 */}
      <div className="text-center">
        <Button
          size="xl"
          className="mt-6 lg:mt-12 xl:mt-[60px] [&]:text-base [&]:font-medium [&]:xl:text-xl"
          onClick={() => {
            const path =
              i18n.language === 'zh'
                ? '/zh/wukong-reviews/#reviews'
                : '/wukong-reviews/#reviews';
            window.location.href = path;
          }}>
          {t('口碑之选-按钮')}
        </Button>
      </div>
    </div>
  );
};

export default PublicPraise;
